__turbopack_context__.v({
  "input": "ssn-input-module-scss-module__GPjuRG__input",
  "prefix": "ssn-input-module-scss-module__GPjuRG__prefix",
});
